import { useEffect, useState } from "react";
import Auticko from "./Auticko";

/**
 * Načítavanie: autíčko ide dookola po ceste, pod ním text.
 *
 * Len pre obrazovky, ktoré vidí zákazník alebo návštevník. V paneloch obsluhy
 * a u vodiča ostáva Loader2 -- tam sa načítava stále dokola a autíčko by
 * po desiatom raze otravovalo.
 *
 * `oneskorenie` (ms): kým neuplynie, nekreslí nič. Rýchla odpoveď tak
 * neblikne autíčkom na zlomok sekundy.
 */
function AutickoLoader({ text = "Načítavam…", oneskorenie = 0, celaStranka = false }) {
  const [viditelny, setViditelny] = useState(oneskorenie <= 0);

  useEffect(() => {
    if (oneskorenie <= 0) return undefined;
    const casovac = setTimeout(() => setViditelny(true), oneskorenie);
    return () => clearTimeout(casovac);
  }, [oneskorenie]);

  if (!viditelny) return null;

  return (
    <div
      className={`auticko-loader${celaStranka ? " auticko-loader--cela-stranka" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="auticko-loader__cesta" aria-hidden="true">
        <Auticko rezim="jazda" sirka={72} />
      </div>
      {text && <p className="auticko-loader__text">{text}</p>}
    </div>
  );
}

export default AutickoLoader;
